import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { useStyles } from './CoachResults.styles'

export const DIRECTORY_SKELETON_CARD_COUNT = 6

function DirectoryCoachCardSkeleton() {
  const classes = useStyles()

  return (
    <div className={classes.skeletonCard} data-testid="directory-coach-skeleton" aria-hidden="true">
      <div className={classes.skeletonPhoto}>
        <Skeleton variant="rect" animation="wave" width="100%" height="100%" />
      </div>
      <div className={classes.skeletonBody}>
        <Skeleton variant="text" animation="wave" width="45%" height={20} />
        <Skeleton variant="text" animation="wave" width="92%" />
        <Skeleton variant="text" animation="wave" width="78%" />
        <Skeleton
          className={classes.skeletonTag}
          variant="rect"
          animation="wave"
          width={88}
          height={22}
        />
      </div>
    </div>
  )
}

export default DirectoryCoachCardSkeleton
